import { HelperText } from '~/components/helper-text'
import type { TIconProps } from '~/components/icon'
import { useInputPasswordProps } from '../../hooks'

export const InputPasswordHelperText = ({
  children,
  withIcon = false,
  iconName,
}: {
  children: React.ReactNode
  withIcon?: boolean
  iconName?: TIconProps['symbol']
}) => {
  const { hasError, disabled, readonly } = useInputPasswordProps()

  return !hasError ? (
    <HelperText
      disabled={disabled}
      readonly={readonly}
      withIcon={iconName && withIcon}
      iconName={iconName}
      iconSize="tiny"
    >
      {children}
    </HelperText>
  ) : null
}
